import ApiClient from "@/domain/core/utils/apiClient"
import client_gateway from "@/services/clients/client_gateway"

const gatewayClient = new ApiClient(client_gateway)

const endpoints = {
    batches: '/dashboard/ecommerce/coupon-batches/',
    redeem: '/dashboard/ecommerce/coupons/redeem/',
    redemptions: '/dashboard/ecommerce/coupon-redemptions/'
}

export default {
    async fetchBatches(picaServiceId) {
        const params = { pica_service_id: picaServiceId }
        return await gatewayClient.get(endpoints.batches, params)
    },

    async redeemCoupon(batchId, userId, picacode = null, effectParamsOverrides = null) {
        const payload = {
            batch_id: batchId,
            user_id: userId
        }
        if (picacode) {
            payload.picacode = picacode
        }
        if (effectParamsOverrides) {
            payload.effect_params_overrides = effectParamsOverrides
        }
        return await gatewayClient.post(endpoints.redeem, payload)
    },

    async fetchRedemptions(userId, picacode) {
        const params = { user_id: userId, picacode: picacode }
        return await gatewayClient.get(endpoints.redemptions, params)
    }
}
